/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 */

import {
  CAROUSEL_ORIGINS,
  LIST_ORIGINS,
  DETAIL_INLINE_ORIGINS,
  DETAIL_STICKY_ORIGINS,
  FLOORPLAN_ORIGINS,
  FormattedOrigin,
  Origin,
} from '@zcode/nr-utils'

export const getFormattedOrigin = (origin: string) => {
  if (origin === Origin.DETAIL_AGENT_BOX || origin === Origin.ADDR_DETAIL_AGENT_BOX) {
    return FormattedOrigin.DETAIL_AGENT
  }
  if (origin === Origin.MAP) {
    return FormattedOrigin.MAP
  }
  if ((LIST_ORIGINS as readonly string[]).includes(origin)) {
    return FormattedOrigin.LIST
  }
  if ((DETAIL_INLINE_ORIGINS as readonly string[]).includes(origin)) {
    return FormattedOrigin.DETAIL_INLINE
  }
  if ((DETAIL_STICKY_ORIGINS as readonly string[]).includes(origin)) {
    return FormattedOrigin.DETAIL_STICKY
  }
  if ((CAROUSEL_ORIGINS as readonly string[]).includes(origin)) {
    return FormattedOrigin.CAROUSEL
  }
  if ((FLOORPLAN_ORIGINS as readonly string[]).includes(origin)) {
    return FormattedOrigin.DETAIL_FLOORPLAN
  }

  return origin
}
